// In frontend/web/src/pages/telemetry/hooks/useRetrieveVideo.ts
import { useMutation } from "@apollo/client";

import {
  RetrieveVideoMutation,
  RetrieveVideoMutationVariables,
} from "../../../API";
import { RETRIEVE_VIDEO } from "../../../common/operations/mutations";

export const useRetrieveVideo = () => {
  const [retrieveVideo, { data, loading }] = useMutation<
    RetrieveVideoMutation,
    RetrieveVideoMutationVariables
  >(RETRIEVE_VIDEO);

  const createVideo = (params: {
    deviceIdClean: string;
    nodeIdClean: string;
    s3Key: string;
    startTime: string;
    endTime: string;
    videoLength?: number;
    timestreamRow?: any;
    ddbRow?: any;
  }) => {
    return retrieveVideo({
      variables: {
        input: {
          deviceIdClean: params.deviceIdClean,
          nodeIdClean: params.nodeIdClean,
          s3Key: params.s3Key,
          startTime: params.startTime,
          endTime: params.endTime,
          videoLength: String(params.videoLength),
          timestreamRow: params.timestreamRow || null,
          ddbRow: params.ddbRow || null,
        },
      },
    });
  };

  return { createVideo, data, loading };
};
